import { render } from "./CandidatoPublico.vue?vue&type=template&id=fa802f7c&ts=true"
import script from "./CandidatoPublico.vue?vue&type=script&lang=ts"
export * from "./CandidatoPublico.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\UniRH\\FrontEnd\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__